import { Injectable } from '@angular/core';

import { ApiApplication } from '@careconne/core/configs/router.config';

import { ApiService } from '../common/api.service';

@Injectable({
  providedIn: 'root',
})
export class GraphTitleService {
  constructor(private readonly http: ApiService) {}

  saveGraphTitleTag(param: any) {
    return this.http.post(ApiApplication.GRAPH_TITLE.CONTROLLER, param);
  }

  getGraphTitleTagList(param: any) {
    return this.http.post(
      ApiApplication.GRAPH_TITLE.CONTROLLER + ApiApplication.GRAPH_TITLE.GRAPH_TITLE_TAG_LIST,
      param,
    );
  }

  getXMLlocal(url: string) {
    return this.http.getXML(url);
  }

  updateGraphXml(param: any) {
    return this.http.post(ApiApplication.GRAPH_TITLE.CONTROLLER + ApiApplication.GRAPH_TITLE.UPDATE_GRAPH_XML, param);
  }
}
